import React from 'react';
import FooterDesktopMenu from './FooterDesktopMenu';
import FooterBottom from './FooterBottom';
import FooterMobileMenu from './FooterMobileMenu';

export default function Footer({ data }) {
  const {
    footerMenu,
    instagram,
    youtube,
    facebook,
    tikTok,
    twitter,
    copyrightText,
    bottomLinks,
    footerMenuMobile,
    lightLogo
  } = data;
  // console.log(data);
  return (
    <footer
      className="clip-right-top bg-primary lg:-mt-[80px] -mt-[20px] relative z-10
      overflow-hidden"
    >
      <div
        className="mx-auto 2xl:px-[80px] xl:px-[40px] lg:px-[80px] px-4 3xl:px-0 w-full lg:w-[100%]
      3xl:w-[80%] 3xl:!max-w-[1570px]"
      >
        <FooterDesktopMenu data={footerMenu} lightLogo={lightLogo}/>
        <FooterMobileMenu data={footerMenuMobile} lightLogo={lightLogo}/>
      </div>
      <FooterBottom
        copyrightText={copyrightText}
        socialMediaLinks={{ instagram, youtube, facebook, tikTok, twitter }}
        bottomLinks={bottomLinks}
      />
    </footer>
  );
}
